import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-unlink",
  templateUrl: "./med-icon-unlink.component.html",
})
export class MedIconUnlinkComponent extends SvgMixinComponent {}
